import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroInformationCircleMini } from '@ng-icons/heroicons/mini';
import { ModalComponent } from '../modal/modal.component';
import { SignerService } from '../../service';
import { SignerRepository } from '../../repository';

@Component({
  selector: 'common-terms-not-signed-alert',
  standalone: true,
  imports: [CommonModule, ModalComponent, TranslateModule, NgIconComponent],
  providers: [
    provideIcons({
      heroInformationCircleMini,
    }),
  ],
  templateUrl: './terms-not-signed-alert.component.html',
  styleUrls: ['./terms-not-signed-alert.component.scss'],
})
export class TermsNotSignedAlertComponent {
  public showAlert = false;

  constructor(
    private readonly signerRepository: SignerRepository,
    private readonly signerService: SignerService,
  ) {
    this.subscribeToTermsSigned();
  }

  public subscribeToTermsSigned(): void {
    this.signerRepository.termsSigned$.subscribe(termsSigned => {
      this.showAlert = termsSigned === false;
    });
  }

  public signTerms(): void {
    this.signerService.reHandleWalletModalSigner();
  }
}
